// extracted by mini-css-extract-plugin
module.exports = {"block":"supportCountry_block__qPo2t","title":"supportCountry_title__paSdI","description":"supportCountry_description__Q3pSp","td":"supportCountry_td__Ediw7"};